<template>
  <div class="section-auth">
    <div class="card-form-login">
      <header-auth header-title="Iniciar sesión"/>

      <v-form ref="form"
        v-model="valid"
        lazy-validation>

        <v-text-field
            v-if="!userValidated"
            label="Email"
            placeholder="Ingresa tu email"
            v-model="email"
            :rules="emailRules"
            color="#222222"
            variant="underlined"
            type="text">
            <template v-slot:prepend-inner>
              <v-icon color="#222222" icon="mdi-email-outline" size="small"/>
            </template>
          </v-text-field>

          <v-text-field
            v-if="userValidated"
            :type="showedPassword ? 'text' : 'password'"
            label="Contraseña"
            placeholder="Ingresa tu contraseña"
            :rules="passwordRules"
            v-model="password"
            color="#222222"
            variant="underlined">
            <template v-slot:prepend-inner>
              <v-icon color="#222222" icon="mdi-lock-outline" size="small"/>
            </template>
            <template v-slot:append-inner>
              <v-icon color="#222222" icon="mdi-eye-outline" size="small" v-if="!showedPassword" v-on:click="togglePassword"/>
              <v-icon color="#222222" icon="mdi-eye-off-outline" size="small" v-if="showedPassword" v-on:click="togglePassword"/>
            </template>
          </v-text-field>
          <div class="error-msg-login" v-if="errorMessage">
            <span>{{errorMessage}}</span>
          </div>
      </v-form>

      <div class="btns-auth">
        <v-btn style="width: 250px;"
          color="#FF5700" rounded
          :disabled="!valid || !emailValid"
          :loading="processing"
          @click="login">
          {{userValidated ? 'Ingresar' : 'Continuar'}}
        </v-btn>
        <v-btn style="margin-top: 30px;"
          color="#FF5700"
          variant="plain" href="/recoverPassword">
          ¿Olvidaste la contraseña?
        </v-btn>
      </div>

      <footer-auth/>
    </div>
    <span class="rights-reserved">© Commercia 2025. Derechos reservados.</span>
  </div>
</template>

<script>
import axios from 'axios'
import FooterAuth from '@/components/login/FooterAuth.vue'
import HeaderAuth from '@/components/login/HeaderAuth.vue'
export default {
  name: 'CommerciaLogin',
  components: {
    HeaderAuth,
    FooterAuth
  },
  data () {
    return {
      email: '',
      password: '',
      showedPassword: false,
      userValidated: false,
      errorMessage: null,
      processing: false,
      valid: false,
      emailRules: [
        v => !!v || 'Campo requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail no válido'
      ],
      passwordRules: [
        v => !!v || 'Campo requerido'
      ]
    }
  },
  beforeCreate () {
    this.$store.dispatch('autoLogin')
  },
  computed: {
    emailValid () {
      return this.email !== ''
    }
  },
  methods: {
    togglePassword () {
      this.showedPassword = !this.showedPassword
    },
    login () {
      this.errorMessage = null
      this.processing = true
      if (this.userValidated) {
        this.apiLogin()
      } else {
        this.apiValidate()
      }
    },
    async apiLogin () {
      axios.post('auth/login', { email: this.email, password: this.password })
        .then(response => {
          return response.data
        }).then(data => {
          if (data.user.role.name === 'master' || data.user.role.name === 'admin' ||
            data.user.role.name === 'manager' || data.user.role.name === 'finance'
          ) {
            axios.defaults.headers = {
              token: data.tokenReturn
            }
            this.$store.dispatch('saveToken', data.tokenReturn)
            this.processing = false
          } else {
            this.errorMessage = null
            this.processing = false
            this.errorMessage = 'Acceso denegado. Contacta al administrador.'
          }
        }).catch(e => {
          this.errorMessage = null
          this.processing = false
          if (e.response.status === 404) {
            this.errorMessage = 'Contraseña incorrecta.'
          } else {
            this.errorMessage = 'Ocurrio un error con el servidor. Estamos resolviendo el problema.'
          }
        })
    },
    async apiValidate () {
      axios.post('auth/validate', { email: this.email })
        .then(response => {
          return response.data
        }).then(_ => {
          this.userValidated = true
          this.processing = false
        }).catch(e => {
          this.processing = false
          if (e.response.status === 404) {
            this.errorMessage = 'Correo no registrado o no cuenta con permisos. Verifica si está escrito correctamente o ponte en contacto con un administrador.'
          } else {
            this.errorMessage = 'Ocurrio un error con el servidor. Estamos resolviendo el problema.'
          }
        })
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/login.css';
</style>
